import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL: API,
  timeout: 25000,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mg_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const IMG = {
  hero: "https://images.unsplash.com/photo-1665827491321-ce05d75c6a32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBwcml2YXRlJTIwY2luZW1hJTIwM2QlMjByZW5kZXJ8ZW58MHx8fHwxNzg0OTE0NDE4fDA&ixlib=rb-4.1.0&q=85",
  theaterSeats: "https://images.unsplash.com/photo-1710131459450-7c384b8be18f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwcml2YXRlJTIwY2luZW1hJTIwM2QlMjByZW5kZXJ8ZW58MHx8fHwxNzg0OTE0NDE4fDA&ixlib=rb-4.1.0&q=85",
  birthday: "https://images.pexels.com/photos/1543762/pexels-photo-1543762.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  proposal: "https://images.pexels.com/photos/37169827/pexels-photo-37169827.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  anniversary: "https://images.pexels.com/photos/30869729/pexels-photo-30869729.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  family: "https://images.unsplash.com/photo-1778949367481-04f79bfc76fb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxmYW1pbHklMjBnYXRoZXJpbmclMjBjZWxlYnJhdGlvbiUyMGx1eHVyeSUyMGRhcmslMjAzZHxlbnwwfHx8fDE3ODQ5MTQ0NTd8MA&ixlib=rb-4.1.0&q=85",
};

// AI-generated 3D images will be served under /api/static/generated/* if present.
export const AI_IMG = (name) => `${API}/static/generated/${name}.png`;

// Prefer AI-generated image, fall back to curated 3D-style stock image.
export function aiOr(name, fallback) {
  return { primary: AI_IMG(name), fallback };
}

export const OCCASIONS = [
  { key: "birthday", label: "Birthdays", tag: "Make every candle count", short: "Make every birthday extra special", img: aiOr("occasion_birthday", IMG.birthday) },
  { key: "proposal", label: "Proposals", tag: "Say it on the big screen", short: "Romantic moments that last forever", img: aiOr("occasion_proposal", IMG.proposal) },
  { key: "anniversary", label: "Anniversaries", tag: "Relive every frame together", short: "Celebrate love in the perfect setting", img: aiOr("occasion_anniversary", IMG.anniversary) },
  { key: "friends", label: "Friends Party", tag: "Your crew, your screening", short: "Fun, laughter & memories together", img: aiOr("occasion_friends", IMG.theaterSeats) },
  { key: "corporate", label: "Corporate Events", tag: "Impress. Engage. Celebrate.", short: "Impress. Engage. Celebrate.", img: aiOr("occasion_corporate", IMG.hero) },
  { key: "family", label: "Family Gatherings", tag: "Warmth, laughter, silver screen", short: "Warmth, laughter, silver screen", img: aiOr("occasion_family", IMG.family) },
  { key: "surprise", label: "Surprise Parties", tag: "The plot twist they'll never forget", short: "The plot twist they'll never forget", img: aiOr("occasion_friends", IMG.hero) },
];

// The 5 headline occasions shown in the marquee cards & icon strip on landing.
export const HEADLINE_OCCASIONS = ["birthday", "proposal", "anniversary", "friends", "corporate"];
